
import { MapLocation } from '@/types/location';

// Aspar Entertainment Center Locations
export const asparEntertainmentCenters: MapLocation[] = [
  {
    id: 46001,
    name: "Aspar Entertainment - Riyadh (Al Munsiyah)",
    type: "Game Center",
    devices: 9,
    coordinates: [24.8436416872551, 46.76267737301189],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
